import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { ChangelogPage } from './changelog';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [ChangelogPage],
    imports: [PagesModule, ComponentsModule]
})
export class ChangelogPageModule {}
